import { createContext } from 'react';
import type { TypedSocket } from './types';

export type SocketContextType = {
  socket: TypedSocket;
  isConnected: boolean;
};

export const SocketContext = createContext<SocketContextType>({} as SocketContextType);
